import { create } from "zustand";

import type { SaveableSection } from "../features/review/sectionSaveHandle";

interface SaveableSectionsState {
  sections: Map<string, SaveableSection>;
  register: (id: string, section: SaveableSection) => void;
  unregister: (id: string) => void;
}

// Registry of every mounted editable review section (Signers today; more to
// come). The save orchestrator (useSaveAllSections) reads this map to
// validate and merge every section's payload into one aggregate save call,
// without needing to know which sections exist.
export const useSaveableSectionsStore = create<SaveableSectionsState>((set) => ({
  sections: new Map(),
  register: (id, section) =>
    set((state) => {
      const sections = new Map(state.sections);
      sections.set(id, section);
      return { sections };
    }),
  unregister: (id) =>
    set((state) => {
      if (!state.sections.has(id)) {
        return state;
      }
      const sections = new Map(state.sections);
      sections.delete(id);
      return { sections };
    }),
}));
